define('PartLookupSearcher.Model', [
	'SCModel',
	'Utils',
], function (SCModelModule, Utils) {
	'use strict';

	var SCModel = SCModelModule.SCModel;

	function PartLookupSearcherModel(model, options) {
		SCModel.call(this, model, options);

		this.urlRoot = function urlRoot() {
			return Utils.getAbsoluteUrl(
				getExtensionAssetsPath(
					'Modules/PartLookupSearcher/SuiteScript2/PartLookupSearcher.Service.ss'
				),
				true
			);
		};
	}

	PartLookupSearcherModel.prototype = Object.create(SCModel.prototype);

	_.extend(PartLookupSearcherModel.prototype, {
		constructor: PartLookupSearcherModel
	})
	
	return PartLookupSearcherModel;
});
